import { isNil } from "@grandvisionhq/utils";
var PaymentStatusLabelKey = /* @__PURE__ */ ((PaymentStatusLabelKey2) => {
  PaymentStatusLabelKey2["BALANCE_DUE"] = "balanceDue";
  PaymentStatusLabelKey2["CREDIT_OWED"] = "creditOwed";
  PaymentStatusLabelKey2["FAILED"] = "failed";
  PaymentStatusLabelKey2["PAID"] = "paid";
  PaymentStatusLabelKey2["PENDING"] = "pending";
  return PaymentStatusLabelKey2;
})(PaymentStatusLabelKey || {});
const getPaymentStatusLabel = (status, intl) => {
  if (isNil(status)) {
    return void 0;
  }
  return intl.getLabel(`account.order.paymentStatus.${PaymentStatusLabelKey[status]}`);
};
export {
  getPaymentStatusLabel
};
//# sourceMappingURL=get-payment-status-label.js.map
